<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h">I</p>
<p class="part-title">YOU</p>
<p class="part-center">Identity</p>
<p class="part-center">Anxiety</p>
<p class="part-center">Money</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?62e8f870